import { Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import InfoTooltip from './InfoTooltip'

const InfoTitle = ({ title, tooltip, isRequired = true }) => {
    return (
        <Stack direction='row' justifyContent='space-between'>
            <Typography>
                {title}
                {isRequired && (
                    <span style={{ marginLeft: 3, color: '#da3a22ff' }}>*</span>
                )}
            </Typography>
            <InfoTooltip description={tooltip} />
        </Stack>
    )
}

InfoTitle.propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    isRequired: PropTypes.bool
}

export default InfoTitle